import { JSX, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import TvCard from "@/components/cards/TvCard/TvCard.tsx";

import { useGetBroadcasts } from "@/hooks/api/broadcast.hooks.ts";

const ChannelsList = (): JSX.Element => {
  const [searchParams] = useSearchParams();
  const tvParam: string | null = searchParams.get("tv");

  const { data } = useGetBroadcasts();

  const filteredData = useMemo(() => {
    if (!data) return [];
    if (!tvParam) return data;
    return data.filter((broadcast) => {
      if (broadcast.category?.id) {
        return broadcast.category?.id.toString() === tvParam;
      }
      return broadcast.category?.toString() === tvParam;
    });
  }, [data, tvParam]);

  if (!data) return <></>;

  return (
    <>
      {filteredData.map((broadcast) => (
        <TvCard
          key={broadcast.id}
          is_free={broadcast.is_free}
          title={broadcast.title}
          id={broadcast.id}
          icon={broadcast.icon}
          quality={broadcast.quality}
        />
      ))}
    </>
  );
};

export default ChannelsList;
